export default "/images/vendor/flag-icon-css/flags/1x1/vc.svg?2614017538c99c0f2ea7b5823d128ae4";